import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.reset = this.reset.bind(this)
    this.reset()

    window.addEventListener("pageshow", this.reset)
    document.addEventListener("turbo:before-cache", this.reset)
  }

  disconnect() {
    window.removeEventListener("pageshow", this.reset)
    document.removeEventListener("turbo:before-cache", this.reset)
  }

  reset() {
    this.element.querySelector("input[type='file']").value = ""
  }
}
